/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BidirectionalActionConfig } from './BidirectionalActionConfig';
import {
    BidirectionalActionConfigFromJSON,
    BidirectionalActionConfigFromJSONTyped,
    BidirectionalActionConfigToJSON,
} from './BidirectionalActionConfig';

/**
 * 
 * @export
 * @interface GetBiDirectionalConfig200Response
 */
export interface GetBiDirectionalConfig200Response {
    /**
     * 
     * @type {BidirectionalActionConfig}
     * @memberof GetBiDirectionalConfig200Response
     */
    data?: BidirectionalActionConfig;
}

/**
 * Check if a given object implements the GetBiDirectionalConfig200Response interface.
 */
export function instanceOfGetBiDirectionalConfig200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetBiDirectionalConfig200ResponseFromJSON(json: any): GetBiDirectionalConfig200Response {
    return GetBiDirectionalConfig200ResponseFromJSONTyped(json, false);
}

export function GetBiDirectionalConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBiDirectionalConfig200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : BidirectionalActionConfigFromJSON(json['data']),
    };
}

export function GetBiDirectionalConfig200ResponseToJSON(value?: GetBiDirectionalConfig200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': BidirectionalActionConfigToJSON(value.data),
    };
}

